import { LitElement, html, animationHelpers } from '@hh/global.js'

class stickyContentHero extends LitElement {
  constructor() {
    super()
    this.heroHolder = this.querySelector('[data-hero-holder]')
  }

  connectedCallback() {
    super.connectedCallback()
    if (!this.heroHolder) { return null }

    animationHelpers.createIntersectionObserver(
      this.heroHolder,
      (inView) => this.classList.toggle('bg-zoom', !inView),
      {
        onlyCallbackOnIntersection: false,
        disableAfterIntersection: false,
        threshold: 0.4,
        rootMargin: '0px 0px '
      }
    )
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('sticky-content-hero', stickyContentHero)
